import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';

import MainTitle from '../common/MainTitle';
import Icon from '../common/Icon';

export default function EducationalProgram() {
  const { t } = useTranslation(['CareersPage']);

  return (
    <section className="educational-program">
      <div className="container">
        <div className="educational-program__title">
          <MainTitle type="dark" className="text--2xl">
            <span>{t('ourEducational')}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {t('program')}
            </span>
          </MainTitle>
        </div>

        <Icon name="spiral-arrow" className="spiral-arrow-icon" />
      </div>
      <div className="educational-program__content">
        <ReactPlayer url="https://www.youtube.com/watch?v=LXb3EKWsInQ" width="100%" height={580} />
        {/* <video
          width="100%"
          height={580}
          controls={false}
          autoPlay={true}
          loop={true}
          muted={true}
          src="https://www.youtube.com/watch?v=LXb3EKWsInQ"
        /> */}
      </div>
    </section>
  );
}
